/* Saved SoundCloud recordings extend the single #favoriten collection.
   References point to original archive rows; this module never creates players. */
(() => {
  'use strict';
  if (window.__asifRadioCollection) return;
  window.__asifRadioCollection = true;
  const KEY = 'asif.radio.saved-recordings.v1';
  const roots = new Map();
  const canonical = value => {
    try {
      const url = new URL(value);
      const parts = url.pathname.split('/').filter(Boolean);
      if (url.protocol !== 'https:' || !['soundcloud.com', 'www.soundcloud.com'].includes(url.hostname)
        || url.username || url.password || url.port || parts.length !== 2
        || ['sets', 'tracks', 'likes', 'reposts'].includes(parts[1])) return '';
      return `https://soundcloud.com/${parts.join('/')}`;
    } catch { return ''; }
  };
  const sanitize = raw => {
    if (raw?.version !== 1 || !Array.isArray(raw.entries)) return [];
    const seen = new Set();
    return raw.entries.filter(entry => entry && canonical(entry.url) === entry.url
      && typeof entry.title === 'string' && entry.title.trim() && entry.title.length <= 240
      && Number.isFinite(entry.savedAt) && entry.savedAt > 0 && entry.savedAt <= Date.now())
      .sort((a, b) => b.savedAt - a.savedAt)
      .filter(entry => { if (seen.has(entry.url)) return false; seen.add(entry.url); return true; })
      .slice(0, 40).map(({ url, title, savedAt }) => ({ url, title, savedAt }));
  };
  let storageAvailable = true;
  const read = fallback => {
    try { return sanitize(JSON.parse(window.localStorage.getItem(KEY) || '{}')); }
    catch { storageAvailable = false; return fallback; }
  };
  let entries = read([]);
  const write = () => {
    try { window.localStorage.setItem(KEY, JSON.stringify({ version: 1, entries })); storageAvailable = true; return true; }
    catch { storageAvailable = false; return false; }
  };
  window.AsIfRadioCollection = { getEntries: () => entries.map(entry => ({ ...entry })), canonicalURL: canonical };
  const cardURL = card => card.dataset.provider === 'spotify' ? '' : canonical(card.dataset.soundcloudUrl);
  const render = root => {
    const cards = [...root.querySelectorAll('[data-radio-recording]')];
    cards.forEach(card => {
      const button = card.querySelector('[data-recording-save]');
      if (!button) return;
      const url = cardURL(card);
      button.hidden = !url;
      if (!url) return;
      const saved = entries.some(entry => entry.url === url);
      button.setAttribute('aria-pressed', String(saved));
      const label = (saved ? button.dataset.labelSaved : button.dataset.labelSave) || '';
      button.setAttribute('aria-label', label.replace('__TITLE__', card.dataset.recordingTitle || ''));
      button.setAttribute('title', label.replace('__TITLE__', card.dataset.recordingTitle || ''));
      const text = button.querySelector('[data-recording-save-label]');
      if (text) text.textContent = label.replace('__TITLE__', card.dataset.recordingTitle || '');
    });
    root.querySelectorAll('[data-recording-storage-notice]').forEach(notice => { notice.hidden = storageAvailable; });
    document.querySelectorAll('[data-asif-radio-favorite-count]').forEach(node => {
      node.textContent = String((window.AsIfRadio?.getState().favorites.length || 0) + entries.length);
    });
    root.dispatchEvent(new CustomEvent('asif:collection-change'));
    window.dispatchEvent(new CustomEvent('asif:collection-change'));

  };
  const renderAll = () => roots.forEach((_, root) => render(root));
  const mount = root => {
    if (roots.has(root)) return;
    const click = event => {
      const button = event.target.closest('[data-recording-save], [data-saved-remove], [data-saved-open]');
      if (!button || !root.contains(button)) return;
      if (button.dataset.savedOpen) {
        const card = [...root.querySelectorAll('[data-radio-recording]')].find(item => cardURL(item) === button.dataset.savedOpen && item.id);
        if (!card) return;
        event.preventDefault();
        window.dispatchEvent(new CustomEvent('asif:recording-reveal', { detail: { card } }));
        card.scrollIntoView({ block: 'center', behavior: 'auto' });
        (card.querySelector('[data-recording-load]') || card)?.focus({ preventScroll: true });
        return;
      }
      const card = button.closest('[data-radio-recording]');
      const url = canonical(button.dataset.savedRemove || (card && cardURL(card)));
      if (!url) return;
      entries = read(entries);
      const previous = entries.slice();
      if (button.dataset.savedRemove || entries.some(entry => entry.url === url)) entries = entries.filter(entry => entry.url !== url);
      else {
        if (entries.length >= 40) { storageAvailable = false; renderAll(); return; }
        const title = (card.dataset.recordingTitle || '').trim().slice(0, 240);
        if (!title) return;
        entries.unshift({ url, title, savedAt: Date.now() }); entries = entries.slice(0, 40);
      }
      if (!write()) entries = previous;
      renderAll();
    };
    root.addEventListener('click', click);
    roots.set(root, () => { root.removeEventListener('click', click); roots.delete(root); });
    render(root);
  };
  const scan = () => {
    entries = read(entries);
    document.querySelectorAll('[data-radio-page]').forEach(mount);
    renderAll();
  };
  document.addEventListener('asif:page:unload', () => roots.forEach(clean => clean()));
  document.addEventListener('asif:page', scan);
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', event => roots.forEach((clean, root) => {
    if (event.target === root || event.target.contains(root)) clean();
  }));
  window.addEventListener('pageshow', scan);
  window.addEventListener('storage', event => { if (event.key === KEY || event.key === null) { entries = read(entries); renderAll(); } });
  scan();
})();
